// extracted by mini-css-extract-plugin
export default {"action":"HardwareDetails_action__exMNW","action_btn":"HardwareDetails_action_btn__OdK8f","container":"HardwareDetails_container__kZtoN","row":"HardwareDetails_row__EtUrp"};